export default {
	name: "CitrusVocabularyList",
	data() {
		return {
			templateId: "",
			items: [],
			navigate: [],
			filteredChar: ""
		}
	},
	computed: {
		getFilterList() {
			if(this.filteredChar.length <= 0) {
				return this.items
			}

			return this.items.filter((term) => term.TERM[0].toUpperCase() == this.filteredChar);
		}
	}
};
